export const singleLotForEdit = () => ({
  id: '',
  title: '',
  description: '',
  categoryId: '',
  lotState: '',
  lotType: '',
  productType: '',
  locationId: '',
  currency: '',
  fixedPrice: '',
  tagIds: [],
  lotImagesToAdd: [],
  imagesIdsToDelete: [],
  mainImageIndex: 0,
});
